'use strict';

angular.module('settingsController', [])

.controller('SettingsController', ['$scope', '$rootScope', '$log', '$location', '$window','SellerService', 'ContactService', 'AgentService',
    function ($scope, $rootScope, $log, $location, $window, SellerService, ContactService, AgentService) {    
    
    $rootScope.header.show = false;
    $scope.showModal = false;
    $scope.page = 'settings';

    $scope.modalOptions = {
        closable: true,
        //duration: 4000,
        extraClasses: ['small'],
        onApprove: function() {
            $scope.hideModal();
        },
        // onDeny: function() {
        //     alert('denied');
        // }
    };

    $scope.openModal = function() {
        $scope.showModal = true;
    };

    $scope.hideModal = function() {
        $scope.showModal = false;
    };
    
    //Check auth credentials
    var currentUser = $rootScope.currentUser
        ,name = currentUser.name
        ,info = currentUser.info
        ,ekey = currentUser.authdata
        ;

   
    $scope.updateUser = function(e) {
        $rootScope.loading = true;
        
        var user = {name: name, info: info};
        
        SellerService.update(ekey, user).then(function(response) {
            $scope.status = response.status;
            $scope.showModal = true;
        });

        $rootScope.loading = false;
    }

}]);